module.exports = __webpack_public_path__ + "static/media/SAS-Logo_rev.ec4e7e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/SAS-Logo_rev.png
// module id = 1620
// module chunks = 0